module.exports = __webpack_public_path__ + "static/media/cx.9faec396.svg";